import React from "react";
import { HelperText } from "react-native-paper";
import { OutlinedInput } from "./OutlinedInput";
import { useTranslation } from "react-i18next";

import {Field} from "../../config/companies/config";

interface TextFieldProps {
  field: Field;
  value: string;
  onChange: (fieldName: string, newValue: any) => void;
  errors?: { [key: string]: string };
}

export const TextField = ({
  field,
  value,
  onChange,
  errors = {},
}: TextFieldProps) => {
  const { t } = useTranslation();

  const handleChange = (newValue: string) => {
    if (field.autoCapitalize === "characters") {
      onChange(field.name, newValue.toUpperCase());
    } else {
      onChange(field.name, newValue);
    }
  };

  const label = t(field.label) + (field.required ? "*" : "");

  const getKeyboardType = () => {
    if (field.type === "email" || field.name === "email")
      return "email-address";
    return "default";
  };

  return (
    <>
      <OutlinedInput
        testID={field.name}
        label={label}
        value={value}
        onChangeText={handleChange}
        secureTextEntry={field.type === "password"}
        keyboardType={getKeyboardType()}
        error={!!errors[field.name]}
        readOnly={field.readOnly}
        disabled={field.readOnly}
        autoFocus={field.autoFocus}
        autoCapitalize={field.autoCapitalize}
      />
      {errors[field.name] && (
        <HelperText type="error">{t(errors[field.name])}</HelperText>
      )}
    </>
  );
};
